import { render, staticRenderFns } from "./Canteen.vue?vue&type=template&id=31ac848b&scoped=true"
import script from "./Canteen.vue?vue&type=script&lang=js"
export * from "./Canteen.vue?vue&type=script&lang=js"
import style0 from "./Canteen.vue?vue&type=style&index=0&id=31ac848b&prod&scoped=cabteeb&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31ac848b",
  null
  
)

export default component.exports